var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimezoneLocationFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C16.4183 2 20 5.58172 20 10C20 16.4183 12 22 12 22C12 22 4 16.4183 4 10C4 5.58172 7.58172 2 12 2ZM12 5.5C9.51472 5.5 7.5 7.51472 7.5 10C7.5 12.4853 9.51472 14.5 12 14.5C14.4853 14.5 16.5 12.4853 16.5 10C16.5 7.51472 14.4853 5.5 12 5.5ZM12 6.5C13.933 6.5 15.5 8.067 15.5 10C15.5 11.933 13.933 13.5 12 13.5C10.067 13.5 8.5 11.933 8.5 10C8.5 8.067 10.067 6.5 12 6.5ZM12 7.7998C11.7239 7.7998 11.5001 8.02375 11.5 8.2998V10C11.5001 10.1279 11.549 10.2559 11.6465 10.3535L12.8486 11.5557C13.0439 11.7509 13.3604 11.7509 13.5557 11.5557C13.7509 11.3604 13.7509 11.0439 13.5557 10.8486L12.5 9.79297V8.2998C12.4999 8.02375 12.2761 7.7998 12 7.7998Z",
    fill: "#00182F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimezoneLocationFilled);
export default __webpack_public_path__ + "static/media/TimezoneLocationFilled.3e9cd83c19eee302dc5af9f5ea962ef0.svg";
export { ForwardRef as ReactComponent };